<template>
  <a-menu-item key="4" @click="showEditProjectModal">
    <EditOutlined />&nbsp;編輯專案&nbsp;
  </a-menu-item>
  <a-modal v-model:open="isOpen" width="800px" title="專案編輯" :centered="isModalCentered" 
      :maskClosable="isMaskClosable" :closable="isMaskClosable" :cancelButtonProps="cancelButtonProps" 
      :confirm-loading="isSavingProject" okText="儲存" cancelText="關閉" @cancel="cancelEditProject" @ok="saveEditProject">
    <a-divider />
    <a-form ref="editProjectForm" :model="formState" name="basic" :rules="formRules" :label-col="{ span: 5 }" 
        :wrapper-col="{ span: 13 }" :disabled="isSavingProject">
      <a-form-item ref="projectName" label="專案名稱" name="projectName">
        <a-input v-model:value="formState.projectName" />
      </a-form-item>
      <a-form-item ref="companyName" label="客戶(公司)名稱" name="companyName">
        <a-input v-model:value="formState.companyName" />
      </a-form-item>
      <a-form-item label="專案設定" name="projectConfig">
        <a-checkbox-group v-model:value="formState.projectConfig">
          <a-space direction="vertical">
            <a-checkbox value="requireBasic" name="projectConfig" :disabled="formState.projectConfig.includes('onlyImported') || formState.projectConfig.includes('onlyImportedJobNo')">基本資料必填&nbsp;<span style="color: red;">(給未提供使用者身分證字號的客戶使用)</span></a-checkbox>
            <a-checkbox value="onlyImported" name="projectConfig" :disabled="formState.projectConfig.includes('requireBasic') || formState.projectConfig.includes('disableIdVerify') || formState.projectConfig.includes('onlyImportedJobNo')">僅允許已匯入人員以證件編號登入&nbsp;<span style="color: red;">(需提供使用者身分證字號)</span></a-checkbox>
            <a-checkbox value="onlyImportedJobNo" name="projectConfig" :disabled="formState.projectConfig.includes('requireBasic') || formState.projectConfig.includes('disableIdVerify') || formState.projectConfig.includes('onlyImported')">僅允許已匯入人員以工號或學號登入&nbsp;<span style="color: red;">(需提供使用者身分證字號)</span></a-checkbox>
            <a-checkbox value="disableIdVerify" name="projectConfig" :disabled="formState.projectConfig.includes('onlyImported') || formState.projectConfig.includes('onlyImportedJobNo')">停用證件編號驗證</a-checkbox>
          </a-space>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item v-if="canSelectQuestionnaireForm" label="問卷填寫介面" name="questionnaireForm">
        <a-radio-group v-model:value="formState.questionnaireForm">
          <a-space direction="horizontal" wrap>
            <a-radio value="LEGACY">傳統版問卷</a-radio>
            <a-radio value="MODERN">新版問卷</a-radio>
          </a-space>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="健檢日期(起訖)" name="checkDateRange">
        <a-range-picker v-model:value="formState.checkDateRange" style="width: 80%" :placeholder="dateRangePlaceholder" />
      </a-form-item>
      <a-form-item label="問卷填寫日期(起訖)" name="expireDateRange">
        <a-range-picker v-model:value="formState.expireDateRange" style="width: 80%" :placeholder="dateRangePlaceholder" />
      </a-form-item>
      <a-form-item label="問卷類型" name="surveyType">
        <a-checkbox-group v-model:value="formState.surveyType">
          <a-space direction="vertical">
            <a-checkbox value="OVER_WORK" v-if="isSurveyTypeVisible('OVER_WORK')" name="surveyType" :disabled="formState.surveyType.includes('OVER_WORK_MIND')">過勞評估</a-checkbox>
            <a-checkbox value="OVER_WORK_MIND" v-if="isSurveyTypeVisible('OVER_WORK_MIND')" name="surveyType" :disabled="formState.surveyType.includes('OVER_WORK')">過勞與心理評估</a-checkbox>
            <a-checkbox value="BSRS5" v-if="isSurveyTypeVisible('BSRS5')" name="surveyType">心情溫度計(簡式健康量表)</a-checkbox>
            <a-checkbox value="MUSCUL" v-if="isSurveyTypeVisible('MUSCUL')" name="surveyType">肌肉骨骼自覺症狀評量表</a-checkbox>
            <a-checkbox value="OVER_LOAD" v-if="isSurveyTypeVisible('OVER_LOAD')" name="surveyType">過負荷問卷</a-checkbox>
            <a-checkbox value="GENERAL_PHYSICAL" v-if="isSurveyTypeVisible('GENERAL_PHYSICAL')" name="surveyType">勞工一般體檢</a-checkbox>
            <a-checkbox value="ELDERLY_WORK_ADAPTABILITY" v-if="isSurveyTypeVisible('ELDERLY_WORK_ADAPTABILITY')" name="surveyType">中高齡工作適能評估&nbsp;<span style="color: red;">(僅開放給未匯入與45歲以上人員填寫)</span></a-checkbox>
            <a-checkbox value="WORKPLACE_UNLAWFUL_ACTS" v-if="authorizedQuestTypes.includes('WORKPLACE_UNLAWFUL_ACTS')" name="surveyType">職場不法侵害風險評估</a-checkbox>
            <a-checkbox value="SELF_APPRAISAL_NUTRITION" v-if="authorizedQuestTypes.includes('SELF_APPRAISAL_NUTRITION')" name="surveyType">自我評核-營養</a-checkbox>
          </a-space>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="備註" name="remark">
        <a-textarea v-model:value="formState.remark" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>
import dayjs from 'dayjs';
import { EditOutlined } from "@ant-design/icons-vue";
import { ref, reactive, defineEmits, defineProps } from 'vue';

import common from "@/common";
import config from "@/config";

const props = defineProps(['project']);

const projectQuestTypes = ref([]);
const authorizedQuestTypes = ref([]);
const canSelectQuestionnaireForm = ref(false);
const editProjectForm = ref();
const dateRangePlaceholder = ["開始日期", "結束日期"];
const isOpen = ref(false);
const isModalCentered = ref(true);
const isMaskClosable = ref(false);
const isSavingProject = ref(false);
const cancelButtonProps = ref({
  disabled: isSavingProject
});
const formState = reactive({});

const emit = defineEmits(['cancel', 'submit-success']);

function newDateWithoutTime(date) {
  return new Date(date.year(), date.month(), date.date(), 0, 0, 0, 0);
}

const formRules = {
  projectName: [{
    required: true,
    message: '請輸入專案名稱',
    trigger: ['change', 'blur']
  }], 
  companyName: [{
    required: true,
    message: '請輸入客戶(公司)名稱',
    trigger: ['change', 'blur']
  }],
  checkDateRange: [{
    required: true,
    message: '請選取健檢日期(起訖)',
    trigger: ['change']
  }],
  expireDateRange: [{
    required: true,
    message: '請選取問卷填寫日期(起訖)',
    trigger: ['change']
  }, {
    message: '「問卷填寫起始日」不可晚於「健檢起始日」',
    trigger: ['change'],
    validator: (rule, value) => {
      if (value == null || 
          value.length <= 1 || 
          formState.checkDateRange == null || 
          formState.checkDateRange.length == 0 || 
          newDateWithoutTime(value[0]) <= newDateWithoutTime(formState.checkDateRange[0])) {
        return Promise.resolve();
      }
      return Promise.reject(rule.message);
    }
  }],
  surveyType: [{
    type: 'array',
    required: true,
    message: '請至少選取一個問卷類型',
    trigger: ['change']
  }]
};

const cancelEditProject = () => {
  isOpen.value = false;
  emit('cancel');
};

const saveEditProject = () => {
  editProjectForm.value.validate()
  .then(() => {
    isSavingProject.value = true;
    common.postRequest(config.mgmtSaveProjectEntity, formState, 
      (response) => {
        resetModalState();
        isOpen.value = false;
        isSavingProject.value = false;
        emit('submit-success', response.data, props.project);
      }, () => {
        isSavingProject.value = false;
      });
  })
  .catch(() => { });
};

const resetModalState = () => {
  formState.url = '';
  formState.projectName = '';
  formState.companyName = '';
  formState.projectConfig = [];
  formState.questionnaireForm = 'LEGACY';
  formState.checkDateRange = [];
  formState.expireDateRange = [];
  formState.surveyType = [];
  formState.remark = '';
}

function getDateByMingoDate(mingoDate) {
  const yearEndIndex = mingoDate.indexOf("-");
  const westYear = 1911 + parseInt(mingoDate.substring(0, yearEndIndex));
  return dayjs(westYear + mingoDate.substring(yearEndIndex), 'YYYY-MM-DD');
}

const initEditProjectModel = () => {
  resetModalState();
  formState.url = props.project.url;
  formState.projectName = props.project.projectName;
  formState.companyName = props.project.companyName;
  const projectConfig = props.project.projectConfig || {};
  formState.questionnaireForm = projectConfig.questionnaireForm || 'LEGACY';
  if (projectConfig.requireBasic) {
    formState.projectConfig.push('requireBasic');
  }
  if (projectConfig.onlyImported) {
    formState.projectConfig.push('onlyImported');
  }
  if (projectConfig.onlyImportedJobNo) {
    formState.projectConfig.push('onlyImportedJobNo');
  }
  if (projectConfig.disableIdVerify) {
    formState.projectConfig.push('disableIdVerify');
  }
  formState.checkDateRange.push(getDateByMingoDate(props.project.mingoCheckDateStart));
  formState.checkDateRange.push(getDateByMingoDate(props.project.mingoCheckDateEnd));
  formState.expireDateRange.push(getDateByMingoDate(props.project.mingoExpireDateStart));
  formState.expireDateRange.push(getDateByMingoDate(props.project.mingoExpireDateEnd));
  props.project.questTypeActions.forEach(
    questTypeAction => formState.surveyType.push(questTypeAction.questType));
  formState.remark = props.project.remark;
};

const isSurveyTypeVisible = (surveyType) => {
  return projectQuestTypes.value.includes(surveyType) || authorizedQuestTypes.value.includes(surveyType);
}

const openEditProjectModal = () => {
  projectQuestTypes.value = [];
  props.project.questTypeActions.forEach(
    questTypeAction => projectQuestTypes.value.push(questTypeAction.questType));
  initEditProjectModel();
  setTimeout(() => isOpen.value = true, 100);
}

const showEditProjectModal = () => {
  common.getRequest(config.mgmtUserEntity, (response) => {
    authorizedQuestTypes.value = response.data.authorizedQuestTypes;
    canSelectQuestionnaireForm.value = response.data.userConfig?.allowQuestionnaireFormSelection === true;
    openEditProjectModal();
  }, (error) => {
    console.error("Failed to get Mgmt User entity. " + error);
    authorizedQuestTypes.value = [];
    canSelectQuestionnaireForm.value = false;
    openEditProjectModal();
  });
};

</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
</style>
